import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";
import GlobeSvg from "components/svg/Globe";
import ArrowDown from "components/svg/ArrowDown";
import { setCurrentLanguage } from "redux/actions/languageActions";
import { languageOptions } from "../../utils/settings-languages";
import { RootState } from "redux/reducers/rootReducer";
import { DEFAULT_LANGUAGE } from "constants/constants";

function TheHeaderLanguages() {
  const dispatch = useDispatch();
  const currentLanguageCode = useSelector((state: RootState) => state.language);
  const currentLanguageName =
    languageOptions.find((lang) => lang.code === currentLanguageCode)?.name ||
    DEFAULT_LANGUAGE;

  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const toggleAccordion = () => {
    setIsAccordionOpen((prev) => !prev);
  };

  const changeLanguage = (code: string) => {
    localStorage.setItem("currentLang", code);
    dispatch(setCurrentLanguage(code));
    setIsAccordionOpen(false);
  };

  const languageButtons = languageOptions.map((lang) => {
    return (
      <button
        key={lang.code}
        className="header-settings-language__change-action"
        onClick={() => changeLanguage(lang.code)}
      >
        {lang.name}
      </button>
    );
  });

  return (
    <div
      className={classnames("header-settings-language", {
        "header-settings-language--is-open": isAccordionOpen,
      })}
    >
      <button
        className="header-settings-language__toggler application-feedback__link"
        onClick={toggleAccordion}
      >
        <GlobeSvg className="header-settings-language__globe-svg" />
        {currentLanguageName.charAt(0).toUpperCase() +
          currentLanguageName.slice(1)}
        <ArrowDown className="header-settings-language__action-svg-arrow" />
      </button>
      <div className="header-settings-language__content">{languageButtons}</div>
    </div>
  );
}

export default TheHeaderLanguages;
